<div class="flex flex-jc-center ta-center" *transloco="let t; read: 'profile'">
	<div class="flex flex-ai-center flex-dir-column">
		<div class="app-text__h2 mbi-10">{{t('title')}}</div>
		<app-user-avatar [user]="user"></app-user-avatar>
		<div class="user-name">{{userFullName}}</div>
		<div class="email">{{user.email}}</div>
		<div class="mti-5" *ngIf="!user.isEmailConfirmed">
			<app-loader [loading]="processingEmailConfirmationLink">
				<app-button [disabled]="processingEmailConfirmationLink" *ngIf="!emailConfirmationLinkSent" appearance="outline" size="s" (click)="sendEmailConfirmationLink()">
					{{'buttons.confirmEmail' | transloco}}
				</app-button>
			</app-loader>
			<div *ngIf="emailConfirmationLinkSent" class="app-text__body-s">
				{{t('emailConfirmationInstructions')}}
			</div>
		</div>
		<div class="mti-5">
			<app-button appearance="outline" size="s" routerLink="/password-change" queryParamsHandling="preserve">
				{{'buttons.changePassword' | transloco}}
			</app-button>
		</div>
		<div class="mti-5">
			<app-loader [loading]="processingLogout">
				<app-button [disabled]="processingLogout" appearance="active" size="s" (click)="logout()">
					{{'buttons.logout' | transloco}}
				</app-button>
			</app-loader>
		</div>
	</div>
</div>